var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9824 10.5102C11.9824 10.8869 11.8386 11.2636 11.5515 11.5508L2.51295 20.5893C1.93798 21.1642 1.00578 21.1642 0.431048 20.5893C-0.143683 20.0146 -0.143683 19.0825 0.431048 18.5075L8.42885 10.5102L0.431328 2.5128C-0.143403 1.93784 -0.143403 1.00591 0.431328 0.43123C1.00606 -0.144012 1.93826 -0.144012 2.51323 0.43123L11.5518 9.46954C11.8389 9.75691 11.9824 10.1336 11.9824 10.5102Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextDate);
export default __webpack_public_path__ + "static/media/nextDate.ad4d6f819e9c4de3f6ccef0ec8f34ca6.svg";
export { ForwardRef as ReactComponent };